module.exports = __webpack_public_path__ + "static/media/support-icon.d32e938b.svg";